var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshotBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40001506_125661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1562 1.61719C17.7905 1.68576 18.4202 1.75719 19.0454 1.83147C19.8471 1.9254 20.5937 2.28733 21.164 2.8586C21.7343 3.42987 22.095 4.177 22.1877 4.9789L22.3934 6.85605M17.1562 22.384C17.7905 22.3155 18.4202 22.244 19.0454 22.1698C19.8471 22.0758 20.5937 21.7139 21.164 21.1426C21.7343 20.5714 22.095 19.8242 22.1877 19.0223L22.3934 17.1452M6.84652 1.61719C6.21223 1.68576 5.58252 1.75719 4.95738 1.83147C4.15562 1.9254 3.40909 2.28733 2.83875 2.8586C2.26842 3.42987 1.90771 4.177 1.81509 4.9789L1.60938 6.85605M6.84652 22.384C6.21223 22.3155 5.58252 22.244 4.95738 22.1698C4.15562 22.0758 3.40909 21.7139 2.83875 21.1426C2.26842 20.5714 1.90771 19.8242 1.81509 19.0223L1.60938 17.1452M14.3122 6.38119H9.6888L8.54195 8.4589L7.94538 8.51033L7.8648 8.51719C6.9048 8.60119 6.11623 9.34005 5.97566 10.2915C5.8488 11.1538 5.73566 12.0435 5.73566 12.9486C5.73566 13.8538 5.8488 14.7452 5.97566 15.6092C6.11623 16.5606 6.90652 17.2995 7.8648 17.3835L7.94538 17.3903C9.25509 17.5035 10.6111 17.62 12.0014 17.62C13.3899 17.62 14.7477 17.5035 16.0574 17.3903L16.1362 17.3835C17.0962 17.2995 17.8848 16.5606 18.0254 15.6092C18.1522 14.7452 18.2671 13.8572 18.2671 12.9503C18.2671 12.0435 18.1522 11.1538 18.0271 10.2932C17.9566 9.82804 17.7319 9.40006 17.389 9.07797C17.0461 8.75589 16.6049 8.55839 16.1362 8.51719L16.0574 8.51033L15.4608 8.4589L14.3122 6.38119Z",
    stroke: "#39ACE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0033 14.4676C13.1005 14.4676 13.7176 13.8505 13.7176 12.7533C13.7176 11.6562 13.1005 11.0391 12.0033 11.0391C10.9062 11.0391 10.2891 11.6562 10.2891 12.7533C10.2891 13.8505 10.9062 14.4676 12.0033 14.4676Z",
    stroke: "#39ACE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40001506_125661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshotBlue);
export default __webpack_public_path__ + "static/media/Screenshot-blue.a1f5e3ba8be7f18caab64b36dbaa1158.svg";
export { ForwardRef as ReactComponent };